module.exports = __webpack_public_path__ + "img/logo.d604cd8c.svg";